import { put, call, takeLatest } from "redux-saga/effects";
import { APIClient } from "../../../helpers/api_helper";
import { changePasswordSuccess, changePasswordError } from "./actions";
import { CHANGE_PASSWORD } from "./actionTypes";
import i18n from "../../../i18n";
const api = new APIClient();

function* changePassword({ payload: { user } }) {
  try {
    const resetUrl = `${process.env.REACT_APP_API_BASE_URL}/api/auth/update-customer-password`;
    const reset = () =>
      api.create(resetUrl, {
        currentPassword: user.currentPassword,
        newPassword: user.newPassword,
      });

    const response = yield call(reset);

    if (response.status_code === 200) {
      yield put(changePasswordSuccess());
    } else {
      yield put(
        changePasswordError(
          response.message ?? i18n.t("auth.changePassword.error")
        )
      );
    }
  } catch (error) {
    yield put(
      changePasswordError(error.message ?? i18n.t("auth.changePassword.error"))
    );
  }
}

function* ChangePasswordSaga() {
  yield takeLatest(CHANGE_PASSWORD, changePassword);
}

export default ChangePasswordSaga;
